import { create } from "zustand";

export const useUserStore = create((set) => ({
  role: "presidente", // "presidente" o "alcalde"
  user: {
    id: 1,
    name: "Usuario",
    barrio: "Centro",
    email: "user@example.com"
  },

  setRole: (role) => set({ role }),
  setUser: (user) => set({ user }),
}));
